import { cmsClient } from '@core/api/API'

export default {
  async fetchSinglePage(id, queryParams = {}) {
    return await cmsClient.get(`/${id}`, {
      params: queryParams,
    })
  },
  async fetchCollection(collectionId, resourceId = null, queryParams = {}) {
    if (resourceId) {
      return await cmsClient.get(`/${collectionId}/${resourceId}`, { params: queryParams })
    }

    return await cmsClient.get(`/${collectionId}`, { params: queryParams })
  },
}
